import { getWrappedTokenAddress } from "./chainUtils";
import { getContract } from "wagmi/actions";
import {
  DUMMY_WALLET,
  GAS_ESTIMATE_MULTIPLIER,
  NATIVE_TOKEN_ADDRESS,
  WRAPPED_ABI,
} from "../config/consts";
import { TokenList } from "../store/global/getAllTokenLists";
import { Hash, parseUnits, PublicClient, WalletClient } from "viem";
import { Chain } from "viem/chains";
import { Amount } from "../types/amount";
import { getTokenDecimals, isAddressEqual } from "./tokenUtils";

//TODO TOKENS: Fix params
export const estimateWrapping = async (
  method: "deposit" | "withdraw",
  contractAddress: string,
  value: Amount,
  walletClient: WalletClient,
  publicClient: PublicClient,
  tokenAddress: Hash,
  tokenList: TokenList
): Promise<Amount> => {
  const contract = getContract({
    address: contractAddress as `0x${string}`,
    abi: WRAPPED_ABI,
    walletClient: walletClient,
  });
  try {
    const amount = parseUnits(
      value.value.toString() as `${number}`,
      getTokenDecimals(tokenAddress, tokenList)
    );
    const gas =
      method === "deposit"
        ? await contract.estimateGas.deposit({
            value: amount,
            account: walletClient.account?.address ?? DUMMY_WALLET,
          })
        : await contract.estimateGas.withdraw([amount], {
            account: walletClient.account?.address ?? DUMMY_WALLET,
          });

    const currentGas = await publicClient.getGasPrice();
    const totalGas = currentGas * gas * GAS_ESTIMATE_MULTIPLIER; // Multiplying by 2 to cover gas volatility
    const gasCostInNativeToken = new Amount(totalGas.toString()).div(
      new Amount((10 ** getTokenDecimals(tokenAddress, tokenList)).toString())
    );
    return gasCostInNativeToken;
  } catch (err) {
    console.log(err);
    return Amount.ZERO;
  }
};

export const isNativeToken = (tokenAddress: Hash, network: Chain) => {
  return isAddressEqual(tokenAddress, NATIVE_TOKEN_ADDRESS);
};
export const isWrapToken = (tokenAddress: Hash, network: Chain) => {
  const wrappedTokenAddress = getWrappedTokenAddress(network);
  return isAddressEqual(tokenAddress, wrappedTokenAddress);
};
